// assets/only-selected-media.js
(() => {
  function hideAllExceptActive(section) {
    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;

    // 1) găsim media activă (Dawn îi pune de obicei o clasă "is-active" / "--active")
    const activeItem =
      gallery.querySelector('.is-active') ||
      gallery.querySelector('.product__media-item--active') ||
      gallery.querySelector('[aria-current="true"]') ||
      gallery.querySelector('[data-active="true"]');

    // dacă nu găsim încă (uneori la schimbare variantă durează o fracțiune), nu facem nimic
    if (!activeItem) return;

    // 2) ascundem toate item-urile media, afișăm doar activul
    const mediaItems = gallery.querySelectorAll('.product__media-item, [data-media-id]');
    mediaItems.forEach((item) => {
      item.style.display = item === activeItem ? '' : 'none';
      item.setAttribute('aria-hidden', item === activeItem ? 'false' : 'true');
    });

    // 3) ascundem thumbnails (șirul de poze dedesubt), ca să nu mai inducă în eroare
    const thumbs =
      section.querySelector('.thumbnail-list') ||
      section.querySelector('.product__media-toggle') ||
      section.querySelector('.slider-buttons') ||
      section.querySelector('.product__media-sublist');

    if (thumbs) thumbs.style.display = 'none';
  }

  function init() {
    const sections = document.querySelectorAll('section[id^="MainProduct-"], .product');
    sections.forEach((section) => {
      // la încărcare
      hideAllExceptActive(section);

      // la orice schimbare în opțiuni (culoare/personalizare)
      section.addEventListener('change', (e) => {
        if (e.target.closest('variant-selects, variant-radios, form')) {
          // Dawn actualizează activul imediat sau după un mic delay; punem un mic timeout sigur
          setTimeout(() => hideAllExceptActive(section), 50);
          setTimeout(() => hideAllExceptActive(section), 200);
        }
      });

      // unele versiuni Dawn trimit event custom
      section.addEventListener('variant:change', () => {
        setTimeout(() => hideAllExceptActive(section), 50);
        setTimeout(() => hideAllExceptActive(section), 200);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();